import { ITableTitle } from './../../../../types/table'

export const STitles: ITableTitle[] = [
  { type: 'header', slug: 'increment' },
  { type: 'header', slug: 'title' },
  { type: 'header', slug: 'updated' },
  { type: 'header', slug: 'created' },
]